





























import Vue from 'vue';

export default Vue.extend({
    name: 'RelationDropdown',
    props: ['selectedOptionId'],
    data() {
        return {
            isOpen: false,
            data: [
                {
                    id: 'Fils',
                    name: 'Fils',
                },
                {
                    id: 'Fille',
                    name: 'Fille',
                },
                {
                    id: 'Neveu',
                    name: 'Neveu',
                },
                {
                    id: 'Nièce',
                    name: 'Nièce',
                },
                {
                    id: 'Conjoint',
                    name: 'Conjoint',
                },
                {
                    id: 'Frère',
                    name: 'Frère',
                },
                {
                    id: 'Soeur',
                    name: 'Soeur',
                },
                {
                    id: 'Petit-enfant',
                    name: 'Petit-enfant',
                },
                {
                    id: 'Gendre',
                    name: 'Gendre',
                },
                {
                    id: 'Belle-fille',
                    name: 'Belle-fille',
                },
                {
                    id: 'Amis / Voisins',
                    name: 'Amis / Voisins',
                },
                {
                    id: 'Médecin',
                    name: 'Médecin',
                },
                {
                    id: 'Assistante social',
                    name: 'Assistante social',
                },
                {
                    id: 'Mandataire judiciaire',
                    name: 'Mandataire judiciaire',
                },
                {
                    id: 'Moi-même',
                    name: 'Moi-même',
                },
                {
                    id: 'Autre',
                    name: 'Autre',
                },
            ],
        };
    },
    computed: {
        placeholderText: function (): any {
            return this.selectedOption ? this.selectedOption.name : 'Choisissez une des options';
        },
        selectedOption: function (): any {
            let optionFound = this.data.find((option: any) => {
                if (option.id == this.selectedOptionId) {
                    return option;
                }
            });
            return optionFound || null;
        },
    },
    methods: {
        selectedItem(selectedItem: any) {
            this.$emit('update:selectedOptionId', selectedItem.id);
            setTimeout(() => {
                this.isOpen = false;
            }, 0);
        },
        closeDropdown(e: MouseEvent) {
            if (this.$refs.dropdown) {
                let targetElement: Node = e.target as Node;
                if (!(this.$refs.dropdown as any).contains(targetElement) && this.isOpen) {
                    this.isOpen = false;
                }
            }
        },
    },
    mounted() {
        document.addEventListener('click', this.closeDropdown.bind(this));
    },
    activated() {
        document.addEventListener('click', this.closeDropdown.bind(this));
    },
    destroyed() {
        document.removeEventListener('click', this.closeDropdown.bind(this));
    },
    deactivated() {
        document.removeEventListener('click', this.closeDropdown.bind(this));
    },
});
